import React from 'react'
import { Radio, Space } from 'antd'
import { getReviewStatusName, SubmissionReviewStatuses } from '../../../../../../constants/submission-review-statuses'
import useQueryParam from '../../../../../../hooks/useQueryParam'
import { REVIEW_STATUS_PARAM } from '../../../../../../constants/query-params'
import useQueryParamSetter from '../../../../../../hooks/useQueryParamSetter'
import { useParams } from 'react-router'

const ReviewFilters = () => {
    const { layerId: questionId } = useParams()
    let reviewStatus = useQueryParam(REVIEW_STATUS_PARAM)
    if (['any', null].includes(reviewStatus)) reviewStatus = 'any'
    else reviewStatus = Number(reviewStatus)

    const setQueryParam = useQueryParamSetter()

    let options = Object.values(SubmissionReviewStatuses).map(status => (
        <Radio key={status} value={status}>
            {getReviewStatusName(status)}
        </Radio>
    ))

    if (questionId !== 'all') {
        options = options.filter(option => option.props.value !== SubmissionReviewStatuses.PARTIALLY_REVIEWED)
    }

    options.unshift(
        <Radio key='any' value='any'>
            Any
        </Radio>,
    )

    const handleChange = event => setQueryParam({ [REVIEW_STATUS_PARAM]: event.target.value })

    return (
        <Radio.Group onChange={handleChange} value={reviewStatus}>
            <Space direction='vertical'>{options}</Space>
        </Radio.Group>
    )
}

export default ReviewFilters
